import {userTrackApi} from '@/apis/ins.js'
export default {
	async userTrack(context, body) {
		return userTrackApi(body)
	}
}